import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import OurServiceOffer from '../../Components/Automation/OurServiceOffer'
import { ChevronRight } from 'lucide-react'
import Perspectives from '../../Components/Accelerating/Perspectives'
import RelatedServices from '../../Components/Accelerating/RelatedServices'
import AccContact from '../../Components/Accelerating/AccContact'
import Banner from '../../Components/Banner'
import ContactSection from '../../Components/home/ContactSection'


const relatedService = [
    {
        id: 1,
        title: "ServiceNow Digital Workflows",
        description: "Make your IT and HR processes simpler and more efficient with automated workflows on ServiceNow, designed to improve everyday operations.",
        image: "/assets/product/p1.png",
        link: "/servicenow-digital-workflows"
    },
    {
        id: 2,
        title: "Enterprise Applications & ERP",
        description: "Simplify your operations and connect your data with modern ERP solutions, helping your team work smarter, faster, and more efficiently every day.",
        image: "/assets/product/p3.png",
        link: "/enterprise-applications-erp"
    },
    {
        id: 3,
        title: "Product Engineering & Digital",
        description: "At Mobikode, we help you bring ideas to life faster with end-to-end product engineering, from concept and design to smooth development and launch.",
        image: "/assets/product/p4.png",
        link: "/product-engineering-digital"
    },
    {
        id: 4,
        title: "Quality Engineering & Performance",
        description: "We build reliable, high-performing applications using continuous testing and smart QA, ensuring smooth performance, better quality, and a seamless user experience.",
        image: "/assets/product/p2.png",
        link: "/quality-engineering-performance"
    }
];

const data = [
    {
        id: 1,
        category: "CLOUD STRATEGY",
        title: "Navigating the Multi-Cloud Landscape for Enterprise Resilience",
        link: "#"
    },
    {
        id: 2,
        category: "DEVOPS CULTURE",
        title: "Breaking Silos: Integrating Dev and Ops for Faster Delivery",
        link: "#"
    },
    {
        id: 3,
        category: "CLOUD SECURITY",
        title: "Zero Trust Architecture: Securing the Cloud from the Ground Up",
        link: "#"
    },
    {
        id: 4,
        category: "COST OPTIMIZATION",
        title: "FinOps: Managing Cloud Spend in a Scalable Environment",
        link: "#"
    }
];

const service = [
    {
        id: 1,
        title: "AWS, Azure & GCP Solutions",
        category: "service",
        desc: "We design and manage secure, scalable cloud environments on leading platforms, helping your business run smoothly, stay reliable, and grow with confidence.",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]",
        link: "/",
    },
    {
        id: 2,
        title: "Cloud Migration & Modernization",
        category: "service",
        desc: "Smoothly moving your legacy applications to the cloud and reshaping them for modern systems, helping your business run faster, scale easier, and grow confidently.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]",
        link: "/cloud-engineering",
    },
    {
        id: 3,
        title: "DevOps & CI/CD Automation",
        category: "service",
        desc: "Making software delivery smoother and faster, helping teams release updates confidently, improve code quality, and build reliable products that grow with your business.",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]",
        link: "/",
    },
    {
        id: 4,
        title: "Kubernetes & Containerization",
        category: "service",
        desc: "We deploy and manage containerized applications in a way that keeps things simple, consistent, and reliable, so your systems run smoothly across any environment.",
        defaultBg: "bg-gradient-to-bl from-[#01386A] to-[#6A85B6]",
        link: "/",
    },
    {
        id: 5,
        title: "Cloud Security & Compliance",
        category: "service",
        desc: "We make sure your cloud systems are secure and fully compliant, so your data stays safe, reliable, and you can focus on growing your business.",
        defaultBg: "bg-gradient-to-tr from-[#01386A] to-[#253B5C]",
        link: "/",
    },
]

function CloudDevOpsEngineering() {
    return (
        <div>
            <AiHero title="Cloud & DevOps Engineering" imgData="/assets/what/c4.png" />
            <section className="w-full py-[50px] lg:py-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row h-auto lg:h-[323px] group">

                        <div className="overflow-hidden w-full lg:max-w-[624px] h-[250px] lg:h-full relative z-10">
                            <img
                                src="/assets/what/item16.png"
                                alt="Cloud DevOps"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>

                        <div className="relative z-20 w-full lg:max-w-[656px] bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] 
                            px-[20px] py-[30px] lg:px-[40px] lg:py-[30px] flex flex-col justify-center
                            -mt-6 lg:mt-0 lg:ml-0">
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-[500] font-graphik text-justify">
                                At Mobikode, we help businesses move from rigid systems to flexible, high-performing cloud environments. Our Cloud & DevOps approach focuses on simplifying deployments, improving collaboration, and building secure, scalable solutions. By automating processes and streamlining workflows, we make it easier for teams to launch faster, reduce errors, and confidently adapt to changing business needs.
                            </p>

                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>

                        </div>

                    </div>
                </div>
            </section>
            <OurServiceOffer service={service} />
            {/* <section className='overflow-hidden'>
                <div className="max-w-[1440px] lg:pb-[80px] pb-[40px] w-full mx-auto lg:px-[80px] px-[20px]">
                    <h6 className="text-center font-[600] lg:text-[31px] text-[20px] lg:pb-[80px] pb-[40px] lg:leading-[40px] leading-[30px] text-[#01386A]">Spotlight</h6>

                    <div className="flex lg:flex-row flex-col gap-5">

                        <div className="w-full lg:w-[65%] mx-auto relative group">
                            <div className="relative w-full h-[350px] lg:h-auto lg:aspect-auto">
                                <img src="/assets/what/img6.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px]">Migrating a Legacy Banking Platform to AWS with Zero Downtime</h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full lg:w-[35%] mx-auto grid gap-[20px]">

                            <div className="relative h-[300px] lg:h-auto">
                                <img src="/assets/what/img5.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px] line-clamp-2">
                                            Automating CI/CD Pipelines for a Global Retailer...
                                        </h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="relative h-[300px] lg:h-auto">
                                <img src="/assets/what/img7.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px] line-clamp-2">
                                            Implementing Kubernetes for High-Scale Microservices...
                                        </h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section> */}
            <section className="w-full pb-[40px] lg:pb-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[15px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row lg:items-center group lg:h-[507px]">
                        <div className="relative lg:absolute top-0 right-0 w-full lg:max-w-[656px] h-[250px] md:h-[350px] lg:h-full bg-gray-100 overflow-hidden">
                            <img
                                src="/assets/what/img8.png"
                                alt="Mobikode Cloud Advantage"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>
                        <div className="relative z-20 w-[92%] sm:w-[85%] lg:w-full max-w-[719px] mx-auto lg:mx-0 bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] px-[20px] py-[30px] lg:px-[60px] lg:py-[80px] -mt-[40px] lg:mt-0">
                            <h3 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora mb-[15px] lg:mb-[35px] leading-[1.3]">
                                The Mobikode Cloud Advantage
                            </h3>
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-graphik font-[500] text-justify">

                                At Mobikode, we help businesses make the most of the cloud in a way that actually works for them. We go beyond simple migration by building secure, scalable, and cost-effective solutions. With strong cloud and DevOps expertise, we ensure your systems grow smoothly with your business and support continuous progress.
                            </p>
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <Perspectives data={data} /> */}
            <RelatedServices relatedService={relatedService} />
            {/* <section className='relative'>
                <img src="/assets/product/bg1.jpg" className='lg:h-[683px] h-[800px] w-full object-cover' alt="" />
                <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px] top-1/2 -translate-y-1/2 absolute left-1/2 -translate-x-1/2">
                    <AccContact />
                </div>
            </section> */}
            <Banner title="Cloud & DevOps Engineering" text=" Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation." />
            <ContactSection/>
        </div>
    )
}

export default CloudDevOpsEngineering